module.exports = __webpack_public_path__ + "./docs/img/icon-method.5f0eebc017ad579dd8ca332c1da9e847.svg";